import SimplebarComponent from 'simplebar-vue/dist/simplebar-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import VueTextareaAutogrowDirective from 'vue-textarea-autogrow-directive/src/VueTextareaAutogrowDirective';

import ErrorHandler from './common/error-handler';
import MainSearch from './common/main-search/main-search';
import LoginModal from './common/modals/login-modal';
import PromoModal from './common/modals/promo-modal';
import RegionSelectionModal from './common/modals/region-selection-modal';
import RegionSelection from './common/region-selection';
import RegionConfirm from './common/region-confirm';
import QuantityInput from './common/quantity-input';
import TextInput from './common/fields/text-input';
import TextInputSuggest from './common/fields/text-input-suggest';
import SelectInput from './common/fields/select-input';
import CustomSelect from './common/fields/custom-select';
import CheckboxInput from './common/fields/checkbox-input';
import RadioGroup from './common/fields/radio-group';
import RatingStars from './common/rating-stars';
import FavoritesBtn from './common/favorites-btn';
import FavoritesCount from './common/favorites-count';
import FavoritesStatusProfile from './common/favorites-status-profile';
import LinkWrapper from './common/link-wrapper';
import SuggestSearch from './common/suggest-search/suggest-search';
import SuggestResultSimple from './common/suggest-search/suggest-result-simple';
import SuggestResultCatalogCoffee from './common/suggest-search/suggest-result-catalog-coffee';
import SuggestResultHeader from './common/suggest-search/suggest-result-header';

import SelectInputOrder from './common/fields/select-input-order';

import RegistrationForm from './common/registration-form/registration-form';

import CheckoutForm from './common/checkout-form/checkout-form';

import '../modules/validation';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('simplebar', SimplebarComponent);
Vue.use(VueTextareaAutogrowDirective);

Vue.component(ErrorHandler.name, ErrorHandler);
Vue.component(MainSearch.name, MainSearch);
Vue.component(LoginModal.name, LoginModal);
Vue.component(PromoModal.name, PromoModal);
Vue.component(RegionSelectionModal.name, RegionSelectionModal);
Vue.component(RegionSelection.name, RegionSelection);
Vue.component(RegionConfirm.name, RegionConfirm);
Vue.component(QuantityInput.name, QuantityInput);
Vue.component(TextInput.name, TextInput);
Vue.component(TextInputSuggest.name, TextInputSuggest);
Vue.component(SelectInput.name, SelectInput);
Vue.component(CustomSelect.name, CustomSelect);
Vue.component(CheckboxInput.name, CheckboxInput);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(RatingStars.name, RatingStars);
Vue.component(FavoritesBtn.name, FavoritesBtn);
Vue.component(FavoritesCount.name, FavoritesCount);
Vue.component(FavoritesStatusProfile.name, FavoritesStatusProfile);
Vue.component(LinkWrapper.name, LinkWrapper);

Vue.component(SuggestSearch.name, SuggestSearch);
Vue.component(SuggestResultSimple.name, SuggestResultSimple);
Vue.component(SuggestResultCatalogCoffee.name, SuggestResultCatalogCoffee);
Vue.component(SuggestResultHeader.name, SuggestResultHeader);

Vue.component(SelectInputOrder.name, SelectInputOrder);

Vue.component(RegistrationForm.name, RegistrationForm);
Vue.component(CheckoutForm.name, CheckoutForm);
